import { deleteDraft } from './states';

export const services = {
  deleteDraft,
};
